import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function ApplicationModal({ show, onHide, onSave }) {
    const [formData, setFormData] = useState({
        user: "",
        app: "CaptureWise",
        deviceId: "",
        type: "Mensal",
        expiration: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        onSave(formData);
        // Reseta o estado para o padrão após salvar
        setFormData({ user: "", app: "CaptureWise", deviceId: "", type: "Mensal", expiration: "" });
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Registrar Nova Licença</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    {/* Campo: Usuário (Input) */}
                    <Form.Group className="mb-4">
                        <Form.Label className="text-bold">Usuário</Form.Label>
                        <Form.Control
                            name="user"
                            type="text"
                            placeholder="Nome do colaborador"
                            value={formData.user}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    {/* Campo: Aplicativo (Select) */}
                    <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold">Aplicativo</Form.Label><br/>
                        <Form.Select
                            name="app"
                            value={formData.app}
                            onChange={handleChange}
                        >
                            <option value="CaptureWise">CaptureWise</option>
                            <option value="DataMiner">DataMiner</option>
                            <option value="GeoSurvey">GeoSurvey</option>
                            <option value="InsightDash">InsightDash</option>
                        </Form.Select>
                    </Form.Group>

                    {/* Campo: ID do Dispositivo (Input) */}
                    <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold">ID do Dispositivo</Form.Label>
                        <Form.Control
                            name="deviceId"
                            type="text"
                            placeholder="Ex: CW-WIN-9921"
                            value={formData.deviceId}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    {/* Campo: Tipo de Assinatura (Select) */}
                    <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold">Tipo de Assinatura</Form.Label><br/>
                        <Form.Select
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                        >
                            <option value="Trial">Trial</option>
                            <option value="Mensal">Mensal</option>
                            <option value="Anual">Anual</option>
                        </Form.Select>
                    </Form.Group>

                    {/* Campo: Data de Expiração (Input Date) */}
                    <Form.Group className="mb-2">
                        <Form.Label className="fw-semibold">Data de Expiração</Form.Label>
                        <Form.Control
                            name="expiration"
                            type="date"
                            value={formData.expiration}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onHide}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleSave} className="px-4">
                    Salvar Licença
                </Button>
            </Modal.Footer>
        </Modal>
    );
}